export default __webpack_public_path__ + "static/media/view-off.ec58ca09.svg";